import { IProductObject } from '@features/categories/typescript';
const GoogleAdwordsListing = (products: IProductObject[], category: string, priceListName: string) => {
  products.forEach((product: IProductObject, index) => {
    if (window?.ga && typeof window.ga === 'function') {
      window.ga('require', 'ec', 'ec.js');
      window.ga('ec:Impression', {
        id: product?.id,
        name: product?.name,
        category,
        list: category,
        price: product.getPrice(priceListName),
        position: index
      });
      window.ga('ec:setAction', 'add');
      window.ga('send', 'event', 'detail view', 'click', 'addToCart');
    }
  });
};
export default GoogleAdwordsListing;